module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', _vm._l((_vm.users), function(user) {
    return _c('div', {
      ref: "tooltip",
      refInFor: true,
      staticClass: "recent_user activity_avatar onlinepeeps"
    }, [_c('a', {
      staticClass: "hint--top-left",
      attrs: {
        "href": user.url,
        "aria-label": _vm.tooltiptitle(user)
      }
    }, [_c('img', {
      staticClass: "ag",
      attrs: {
        "src": user.thumb,
        "alt": user.name,
        "height": "50",
        "width": "50"
      }
    })]), _vm._v(" "), (user.last_seen_one_hour_ago) ? _c('div', {
      staticClass: "bg-green pos-absolute bottom-0 right-0 rounded-50",
      attrs: {
        "id": "indicatoronline"
      }
    }) : _vm._e()])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37150034!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/RecentUsers.vue
// module id = 1549
// module chunks = 1